import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    getAddressList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberAddress/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    addAndUpdateAddress({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MemberAddress/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    setMemberAddressDefalut({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MemberAddress/SetDefalut',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    deleteMemberAddress({commit},payload) {
        return new Promise((resolve, reject) => {
            api.delete('/MemberAddress/Delete',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addressManage.js